<section id="home" class="slider_area">
    <div id="carouselThree" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
            <li data-target="#carouselThree" data-slide-to="0" class="active"></li>


        </ol>
        <div class="carousel-inner">

            <div class="carousel-item active">
                <div class="container">
                    <div class="row flex-container">
                        <div class="col-lg-7">
                            <div class="slider-content">
                                <h1 class="title">{{'CALCULATORS.TITLE' | translate }}</h1>
                                <p class="text">{{'CALCULATORS.TITLE_DESCRIPTION_SHORT' | translate }}</p>
                                <div class="slider-buttons">
                                    <div class="button-wrap">
                                        <a href="https://admin.propero.io/" target="_blank" class="btn primary-btn">
                                            Propero Assistant
                                        </a>
                                        <span i18n="@@mainSubtitleAdditionalText" class="btn-subtext">
                                            {{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}
                                        </span>
                                    </div>

                                    <div class="button-wrap">
                                        <a routerLink="/solution-personalised" class="btn secondary-btn"
                                            i18n="@@mainPersonalizedOffer">
                                            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="slider-image">
                                <img src="assets/images/slider/4.png" alt="Hero">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <a class="carousel-control-prev" href="#carouselThree" role="button" data-slide="prev">
            <i class="lni lni-arrow-left"></i>
        </a>
        <a class="carousel-control-next" href="#carouselThree" role="button" data-slide="next">
            <i class="lni lni-arrow-right"></i>
        </a>
    </div>
</section>


<section id="features" class="features-area">
    <div class="container">
        <div class="section-title">
            <h3 class="title">{{'CALCULATORS.TITLE' | translate }}</h3>
            <p class="text">{{'CALCULATORS.TITLE_DESCRIPTION_LONG' | translate }}</p>
        </div>

        <div class="features-grid">
            <div class="feature-widget">
                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-apartment"></i>
                    </div>
                    <h4 class="widget-title">
                        <a routerLink="/calculator1" class="features-title">{{
                            'CALCULATORS.FEATURE1_TITLE' | translate }}</a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        {{'CALCULATORS.FEATURE1_TEXT' | translate }}
                    </p>
                    <div class="features-btn-wrapper">
                        <a class="features-btn" routerLink="/calculator1">{{ 'CALCULATORS.COMPUTE' |
                            translate }}</a>
                    </div>
                </div>
            </div>

            <div class="feature-widget">
                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-calculator"></i>
                    </div>
                    <h4 class="widget-title">
                        <a class="features-title" routerLink="/calculator2">{{
                            'CALCULATORS.FEATURE2_TITLE' | translate }}</a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        {{'CALCULATORS.FEATURE2_TEXT' | translate }}
                    </p>
                    <div class="features-btn-wrapper">
                        <a class="features-btn" routerLink="/calculator2">{{ 'CALCULATORS.COMPUTE' |
                            translate }}</a>
                    </div>
                </div>
            </div>

            <div class="feature-widget">
                <div class="widget-header">
                    <div class="widget-icon">
                        <i class="lni lni-cog"></i>
                    </div>
                    <h4 class="widget-title">
                        <a class="features-title" routerLink="/calculator3">{{
                            'CALCULATORS.FEATURE3_TITLE' | translate }}</a>
                    </h4>
                </div>
                <div class="widget-content">
                    <p class="widget-text">
                        {{'CALCULATORS.FEATURE3_TEXT' | translate }}
                    </p>
                    <div class="features-btn-wrapper">
                        <a class="features-btn" routerLink="/calculator3">{{ 'CALCULATORS.COMPUTE' |
                            translate }}</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>

<section id="contact" class="contact-area grey-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-30">
                    <h3 class="title">{{ 'HOME.SECTION_CONTACTUS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="contact-wrapper">
                    <h4 class="contact-title">
                        <i class="lni lni-envelope"></i>
                        {{ 'HOME.TEXT_MESSAGE' | translate }}
                    </h4>
                    <form #contactForm="ngForm">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.NAME' | translate }}</label>
                                    <div class="input-items">
                                        <input type="text" name="name" placeholder="{{ 'HOME.NAME' | translate }}"
                                            [(ngModel)]="contactItem.subject" required>
                                        <i class="lni lni-user"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-input">
                                    <label>{{ 'HOME.EMAIL' | translate }}</label>
                                    <div class="input-items">
                                        <input type="email" name="email" placeholder="{{ 'HOME.EMAIL' | translate }}"
                                            [(ngModel)]="contactItem.email" required>
                                        <i class="lni lni-envelope"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-input">
                                    <label>{{ 'HOME.MESSAGE' | translate }}</label>
                                    <div class="input-items textarea">
                                        <textarea name="message" placeholder="{{ 'HOME.MESSAGE' | translate }}"
                                            [(ngModel)]="contactItem.content" required></textarea>
                                        <i class="lni lni-pencil-alt"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="text-center">

                                    <div class="page-button">
                                        <div class="features-btn-wrapper">
                                            <a (click)="send()" class="features-btn">
                                                <i class="lni lni-arrow-right"></i>
                                                {{'HOME.SEND' |
                                                translate }}
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

























<section class="features-area white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">{{'CALCULATORS.TITLE' | translate }}</h3>
                    <p class="text">{{'CALCULATORS.TITLE_DESCRIPTION_LONG' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">

            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">
                    <div class="features-title-icon d-flex justify-content-between">
                        <h4>
                            <a routerLink="/calculator1" class="features-title">{{
                                'CALCULATORS.FEATURE1_TITLE' | translate }}</a>
                        </h4>
                        <div class="features-icon">
                            <i class="lni lni-display-alt"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>
                    <div class="features-content">
                        <p class="tooltip-text-content text">{{ 'CALCULATORS.FEATURE1_TEXT' | translate }}</p>
                        <a class="features-btn" routerLink="/calculator1">{{ 'CALCULATORS.COMPUTE' |
                            translate }}</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">
                    <div class="features-title-icon d-flex justify-content-between">
                        <h4>
                            <a class="features-title" routerLink="/calculator2">{{
                                'CALCULATORS.FEATURE2_TITLE' | translate }}</a>
                        </h4>
                        <div class="features-icon">
                            <i class="lni lni-files"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>
                    <div class="features-content">
                        <p class="tooltip-text-content text">{{ 'CALCULATORS.FEATURE2_TEXT' | translate }}</p>
                        <a class="features-btn" routerLink="/calculator2">{{ 'CALCULATORS.COMPUTE' |
                            translate }}</a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-7 col-sm-9">
                <div class="single-features mt-40">
                    <div class="features-title-icon d-flex justify-content-between">
                        <h4><a class="features-title" routerLink="/calculator3">{{ 'CALCULATORS.FEATURE3_TITLE' |
                                translate
                                }}</a></h4>
                        <div class="features-icon">
                            <i class="lni lni-layers"></i>
                            <img class="shape" src="assets/images/Shape-1.svg" alt="Shape">
                        </div>
                    </div>
                    <div class="features-content">
                        <p class="text tooltip-text-content ">{{ 'CALCULATORS.FEATURE3_TEXT' | translate }}</p>
                        <a class="features-btn" routerLink="/calculator3">{{ 'CALCULATORS.COMPUTE' |
                            translate }}</a>
                    </div>
                </div>
            </div>

        </div>

    </div>
</section>